import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { getData } from '../Services/api';

const RouteDetails = () => {
  const { id } = useParams();
  const [values, setValues] = useState({
    route_name: ""
  });

  const fetchRoutes = async () => {
    try {
      const res = await getData(`/routes/${id}`);
      if (res.status) {
        setValues(res.data || {})
      }
    } catch (error) {
      console.log("error fetch routes details", error)
    }
  }

  useEffect(() => {
    fetchRoutes();
  }, [id])
  return (
    <>
      <div className="pc-container">
        <div className="pc-content">
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/routes/route-list">Routes</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      Route Details
                    </li>
                  </ul>
                </div>
                <div className="col-md-12">
                  <div className="page-header-title">
                    <h2 className="mb-0">Route Details</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h5>Route Details</h5>
                </div>
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="form-label">Route Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Route"
                            name='route_name'
                            value={values.route_name}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </form >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default RouteDetails

